import { render } from "./CreateVlanIpRange.vue?vue&type=template&id=2eddb264&scoped=true"
import script from "./CreateVlanIpRange.vue?vue&type=script&lang=js"
export * from "./CreateVlanIpRange.vue?vue&type=script&lang=js"

import "./CreateVlanIpRange.vue?vue&type=style&index=0&id=2eddb264&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eddb264"]])

export default __exports__